import { render, staticRenderFns } from "./LoginDialog.vue?vue&type=template&id=77a4f87c&scoped=true"
import script from "./LoginDialog.vue?vue&type=script&lang=ts"
export * from "./LoginDialog.vue?vue&type=script&lang=ts"
import style0 from "./LoginDialog.vue?vue&type=style&index=0&id=77a4f87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a4f87c",
  null
  
)

export default component.exports